<canvas #chartCanvas [height]="height" class="chart-canvas"> </canvas>
